import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import "../../styles.css";
import { Button, Image, Input, Select, TimePicker } from "antd";
import { ProfileShopDetailSchema } from "../validationSchema";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { URLS } from "../../API/API endpoints";
import axiosInstance from "../../AxiosInstance";
import UpdatedProfile from "../../modals/UpdatedProfile";
import { InputBox } from "../CustomWidgets/InputBox";
import { useTranslation } from "react-i18next";
import UploadMediaonly from "../upload-imageonly";
import {
  RetailerShopImagesUpload,
  ShopImageUpload,
  UpdateRetailerDetails,
} from "../../API  Functions/ProfileFunctions";
import { uploadImage } from "../../API  Functions/InventoryFunctions";
import LoadingSpinner from "../Loading";
import { checkPermission } from "../../Utils/permissionHelper";
import moment from "moment";

const ShopLocation = ({ onDataSubmit, data }) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
  const store_id = useSelector((state) => state.login?.user?.store_id);
  const isGinne = useSelector((state) => state?.geneLoginReducer?.isGinneLogin);
  const contractType =
    useSelector((state) => state.login.contractType) || "Cashier_Ecom";
  const [showUpdatedProfile, setShowUpdatedProfile] = useState(false);
  const [restricted, setrestricted] = useState(true);
  const [loading, setLoading] = useState(false);
  const [allMethods, setAllMethods] = useState([]);
  const [selectedMethods, setSelectedMethods] = useState([]);

  const company_id = useSelector(
    (state) => state?.login?.user?.result?.company_id,
  );
  const is_lahloob = useSelector(
    (state) => state.login?.user?.result?.is_lahloob,
  );

  useEffect(() => {
    if (data) {
      formik?.setValues({
        street: data?.retailer_details?.shop_address?.street || "",
        street_2: data?.retailer_details?.shop_address?.street2 || "",
        city: data?.retailer_details?.shop_address?.city || "",
        governate: data?.retailer_details?.shop_address?.state || "",
        zipcode: data?.retailer_details?.shop_address?.zip || "",
        country: data?.retailer_details?.shop_address?.country || "",
        longitude: data?.retailer_details?.longitude || "",
        latitude: data?.retailer_details?.latitude || "",
        prepration_time:
          data?.retailer_details?.order_preperation_time || "00:00",
        minimum_order_value: data?.retailer_details?.min_order_value || 0,
        costing_method: data?.retailer_details?.costing_method || "",
      });

      const methodFromAPI = data?.retailer_details?.payment_method || "COD";
      const matchedMethod = allMethods.find(
        (m) => m.apiValue === methodFromAPI,
      );
      if (matchedMethod) {
        setSelectedMethods([matchedMethod]);
      }

      setrestricted(true);
    }
  }, [data, allMethods]);

  const formik = useFormik({
    initialValues: {
      street: data?.retailer_details?.shop_address?.street || "",
      street_2: data?.retailer_details?.shop_address?.street2 || "",
      city: data?.retailer_details?.shop_address?.city || "",
      governate: data?.retailer_details?.shop_address?.state || "",
      zipcode: data?.retailer_details?.shop_address?.zip || "",
      country: data?.retailer_details?.shop_address?.country || "",
      longitude: data?.retailer_details?.longitude || "",
      latitude: data?.retailer_details?.latitude || "",
      prepration_time:
        data?.retailer_details?.order_preperation_time || "00:00",
      minimum_order_value: data?.retailer_details?.min_order_value || 0,
      costing_method: data?.retailer_details?.costing_method || "",
    },

    // validationSchema: ProfileShopDetailSchema,
    validateOnChange: false,
    validateOnBlur: false,

    onSubmit: async (values) => {
      if (!checkPermission("/settings/profile", isGinne)) {
        return;
      }
      setLoading(true);
      try {
        const payload = {
          user_id: user_id,
          street: values.street,
          street_2: values.street_2,
          city: values.city,
          longitude: values.longitude,
          latitude: values.latitude,
          order_preperation_time: values.prepration_time,
          min_order_value: Number(values.minimum_order_value),
          ...(!data?.retailer_details?.is_costing_method_set && {
            costing_method: values.costing_method,
          }),
          payment_method: selectedMethods[0]?.apiValue || "COD",
        };
        const response = await UpdateRetailerDetails(payload);

        if (response?.status === "Update Successfully") {
          setShowUpdatedProfile(true);
          setrestricted(true);
          onDataSubmit();
          setLoading(false);
        }
      } catch (error) {
        console.error("Error during submission:", error);
      }
    },
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Submitting form...");

    if (formik.errors && Object.keys(formik.errors).length > 0) {
      console.log("Formik errors:", formik.errors);
      return;
    }

    formik.handleSubmit();
  };

  useEffect(() => {
    const methods = [
      { id: 1, name: "COD", apiValue: "COD" },
      { id: 2, name: "COD & BANK", apiValue: "COD_BANK" },
    ];
    setAllMethods(methods);

    // ✅ Default to COD if nothing from API yet
    setSelectedMethods([methods[0]]);
  }, []);

  const convertTo12HourFormat = (time24) => {
    if (time24 === "24:00") {
      return "12:00 AM";
    }
    const [hours, minutes] = time24.split(":").map(Number);
    const period = hours >= 12 ? "PM" : "AM";
    const hours12 = hours % 12 || 12;
    return `${hours12}:${String(minutes).padStart(2, "0")} ${period}`;
  };

  const convertTo24HourFormat = (time12) => {
    const [timePart, period] = time12.split(" ");
    const [hours, minutes] = timePart.split(":").map(Number);
    let hours24 = hours;
    if (period === "PM" && hours < 12) {
      hours24 = hours + 12;
    } else if (period === "AM" && hours === 12) {
      hours24 = 0;
    }
    return `${String(hours24).padStart(2, "0")}:${String(minutes).padStart(
      2,
      "0",
    )}`;
  };

  const togglePaymentMethod = (methodObj) => {
    setSelectedMethods([methodObj]); // ✅ always only one selected
    setrestricted(false);
  };

  return (
    <>
      {loading && <LoadingSpinner />}

      <form onSubmit={handleSubmit} className="min-h-screen overflow-x-hidden">
        {/* ===== Address Section ===== */}
        <div className="text-[17px] font-medium mt-2 md:mt-6 mx-2 md:mx-4">
          {t("Address & Location")}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 mx-0 md:mx-4 mt-4">
          <div className="w-full">
            <InputBox
              name="street"
              label={t("street")}
              placeholder="street"
              onChange={(val) => {
                formik.handleChange(val);
                setrestricted(false);
              }}
              onBlur={formik.handleBlur}
              value={formik.values.street}
            />
          </div>

          <div className="flex flex-col sm:flex-row gap-3">
            <div className="w-full">
              <InputBox
                name="governate"
                label={t("Governate")}
                backgroundColor={"#EBEBEB"}
                disabled
                value={formik.values.governate}
              />
            </div>

            <div className="w-full">
              <InputBox
                name="zipcode"
                label={t("zip")}
                backgroundColor={"#EBEBEB"}
                disabled
                value={formik.values.zipcode}
              />
            </div>
          </div>

          <div className="w-full">
            <InputBox
              name="street_2"
              label={t("Street 2")}
              placeholder="Street 2"
              onChange={(val) => {
                formik.handleChange(val);
                setrestricted(false);
              }}
              value={formik.values.street_2}
            />
          </div>

          <div className="w-full">
            <InputBox
              name="country"
              label={t("country")}
              backgroundColor={"#EBEBEB"}
              disabled
              value={formik.values.country}
            />
          </div>

          <div className="w-full">
            <InputBox
              name="city"
              label={t("city")}
              backgroundColor={"#EBEBEB"}
              onChange={(val) => {
                formik.handleChange(val);
                setrestricted(false);
              }}
              value={formik.values.city}
            />
          </div>

          {/* Lat Long */}
          <div className="flex flex-col sm:flex-row gap-3 col-span-1 sm:col-span-2">
            <InputBox
              name="latitude"
              label={t("Latitude")}
              backgroundColor={"#EBEBEB"}
              disabled
              value={formik.values.latitude}
            />

            <InputBox
              name="longitude"
              label={t("Longitude")}
              backgroundColor={"#EBEBEB"}
              disabled
              value={formik.values.longitude}
            />
          </div>

          <div className="col-span-1 sm:col-span-2">
            <Button
              type="button"
              className="w-full sm:w-[220px] text-primaryBlue font-semibold border border-primaryBlue"
              onClick={() => {
                if (!checkPermission("/settings/profile", isGinne)) return;

                navigator.geolocation?.getCurrentPosition((position) => {
                  const { latitude, longitude } = position.coords;
                  formik.setFieldValue("latitude", latitude);
                  formik.setFieldValue("longitude", longitude);
                  setrestricted(false);
                });
              }}
            >
              {t("Get Lat & Long")}
            </Button>
          </div>
        </div>

        {/* ===== Costing Method ===== */}
        <div className="text-[17px] font-medium mt-8 md:mx-4">
          {t("Costing Method")}
        </div>

        <div className="mx-4 sm:mx-7 mt-2">
          {data?.retailer_details?.is_costing_method_set ? (
            <InputBox
              backgroundColor={"#EBEBEB"}
              disabled
              value={
                data?.retailer_details?.costing_method === "AVCO"
                  ? t("Average Costing")
                  : t("First In First Out")
              }
            />
          ) : (
            <Select
              className="w-full"
              value={formik.values.costing_method}
              onChange={(value) => {
                formik.setFieldValue("costing_method", value);
                setrestricted(false);
              }}
            >
              <Select.Option value="AVCO">{t("Average Costing")}</Select.Option>
              <Select.Option value="FIFO">
                {t("First In First Out")}
              </Select.Option>
            </Select>
          )}
        </div>

        {/* ===== Shop Timings ===== */}
        {contractType !== "Cashier" && (
          <>
            <div className="text-[17px] font-medium mt-8 md:mx-4">
              {t("shop_timings")}
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4 mx-4 sm:mx-7">
              {!is_lahloob && (
                <div className="w-[300px] md:w-full leading-[0px] ">
                  <label className="text-[14px] text-[#5C5C5C]">
                    {t("prepartion_time")}{" "}
                  </label>
                  <div className="mt-4">
                    <TimePicker
                      format="HH:mm"
                      name="prepration_time"
                      className={`w-full border leading-none text-[#5C5C5C] text-sm rounded-md p-2 ${
                        formik.touched.prepration_time &&
                        formik.errors.prepration_time
                          ? "border-red"
                          : "border-[#ccc]"
                      }`}
                      onChange={(time, timeString) => {
                        formik.setFieldValue("prepration_time", timeString);
                        setrestricted(false);
                      }}
                      value={
                        formik.values.prepration_time
                          ? moment(formik.values.prepration_time, "HH:mm")
                          : null
                      }
                      required
                    />
                    {formik.errors.prepration_time && (
                      <div className="text-red text-sm h-2 mt-0 ml-1">
                        {formik.errors.prepration_time}
                      </div>
                    )}
                  </div>
                </div>
              )}

              <div className="w-[300px] md:w-full leading-[0px] ">
                <label className="text-[14px] text-[#5C5C5C]">
                  {t("min_order_value")}
                </label>

                <div className="relative mt-4">
                  <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-[#5C5C5C] text-sm bg-white px-1 z-10">
                    EGP
                  </span>
                  <Input
                    style={{
                      WebkitAppearance: "none",
                      MozAppearance: "textfield",
                      paddingLeft: "3rem",
                      paddingRight: "1rem",
                    }}
                    type="number"
                    className={`h-10 w-full bg-transparent text-[#5C5C5C] text-sm text-body outline-none focus:outline-none rounded-lg border p-3 font-[inherit] font-normal ${
                      formik.errors.minimum_order_value ? "" : ""
                    }`}
                    name="minimum_order_value"
                    placeholder="Enter value"
                    onChange={(val) => {
                      formik.handleChange(val);
                      setrestricted(false);
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.minimum_order_value}
                  />
                  {formik.errors.minimum_order_value && (
                    <div className="text-red text-sm h-2 mt-0 ml-1">
                      {formik.errors.minimum_order_value}
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Payment Methods */}
            <div className="text-[17px] font-medium mt-8 md:mx-4">
              {t("E-Order Payment Methods")}
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 md:flex md:flex-wrap mx-4 sm:mx-7 mt-3 gap-3">
              {allMethods.map((paymentMethod) => {
                const isSelected = selectedMethods?.some(
                  (item) => item.id === paymentMethod.id,
                );

                return (
                  <div
                    key={paymentMethod.id}
                    className={`w-full sm:w-[140px] h-[45px] flex items-center justify-center rounded-lg border cursor-pointer ${
                      isSelected
                        ? "border-primaryBlue text-primaryBlue"
                        : "border-gray-300"
                    }`}
                    onClick={() => togglePaymentMethod(paymentMethod)}
                  >
                    {t(paymentMethod.name)}
                  </div>
                );
              })}
            </div>
          </>
        )}

        {/* Buttons */}
        <div className="mt-8 mb-10 mx-4 sm:mx-7 flex flex-row gap-3">
          <button
            type="submit"
            className="w-full sm:w-[180px] h-[45px] bg-primaryBlue text-white rounded-lg disabled:opacity-50"
            // disabled={restricted}
          >
            {t("update_and_save")}
          </button>

          <Button
            className="w-full sm:w-[180px] h-[45px] border border-primaryBlue text-primaryBlue"
            onClick={() => {
              formik?.setValues({
                street: data?.retailer_details?.shop_address?.street || "",
                street_2: data?.retailer_details?.shop_address?.street2 || "",
                city: data?.retailer_details?.shop_address?.city || "",
                governate: data?.retailer_details?.shop_address?.state || "",
                zipcode: data?.retailer_details?.shop_address?.zip || "",
                country: data?.retailer_details?.shop_address?.country || "",
                longitude: data?.retailer_details?.longitude || "",
                latitude: data?.retailer_details?.latitude || "",
                prepration_time:
                  data?.retailer_details?.order_preperation_time || "00:00",
                minimum_order_value:
                  data?.retailer_details?.min_order_value || 0,
                costing_method: data?.retailer_details?.costing_method || "",
              });
              // Reset payment method
              const methodFromAPI =
                data?.retailer_details?.payment_method || "COD";
              const matchedMethod = allMethods.find(
                (m) => m.apiValue === methodFromAPI,
              );
              if (matchedMethod) {
                setSelectedMethods([matchedMethod]);
              }
              setrestricted(true);
            }}
          >
            {t("cancel")}
          </Button>
        </div>
      </form>
      {showUpdatedProfile && (
        <UpdatedProfile
          onClose={() => setShowUpdatedProfile(false)}
          message={t("Shop Details")}
        />
      )}
    </>
  );
};

export default ShopLocation;
